module.exports = __webpack_public_path__ + "img/dog_car.8675350b.png";